import { render, staticRenderFns } from "./RegistrationStatusCard.vue?vue&type=template&id=551d4e54&scoped=true"
import script from "./RegistrationStatusCard.vue?vue&type=script&lang=ts"
export * from "./RegistrationStatusCard.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationStatusCard.vue?vue&type=style&index=0&id=551d4e54&prod&lang=scss"
import style1 from "./RegistrationStatusCard.vue?vue&type=style&index=1&id=551d4e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551d4e54",
  null
  
)

export default component.exports